import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CustomCurrencyPipe } from '../../../../shared/pipes/custom-currency/custom-currency.pipe';

@Component({
    selector: 'app-financial-card',
    templateUrl: './financial-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomCurrencyPipe]
})
export class FinancialCardComponent {
    public readonly title = input<string>();
    public readonly subtitle = input<string>();
    public readonly amount = input<number>();
    public readonly ammountShouldBeGreen = input<boolean>();
    public readonly currency = input<boolean>();
}
